module.exports = __webpack_public_path__ + "workspace/static/img/tenantMgmtMasterMsspNine.6928fb0.png";